package com.example.impostergame.ui.theme

import androidx.compose.ui.graphics.Color

val Purple80 = Color(0xFFD0BCFF)
val PurpleGrey80 = Color(0xFFCCC2DC)
val Pink80 = Color(0xFFEFB8C8)

val Purple40 = Color(0xFF6650a4)
val PurpleGrey40 = Color(0xFF625b71)
val Pink40 = Color(0xFF7D5260)

// Elegant Aesthetic Palette
val SageGreen = Color(0xFF8DAA91)
val MutedRose = Color(0xFFC78B8B)
val SandBeige = Color(0xFFD6CFC7)
val DeepCharcoal = Color(0xFF242424)
val OffWhite = Color(0xFFF8F7F2)

// Adaptivni tonovi
val SoftCream = Color(0xFFFDF5E6)
val SoftClay = Color(0xFFE8D7C3)
val DarkEarthy = Color(0xFF3E3A33)

// Original legacy colors (za svaki slučaj)
val BlueGradient = Color(0xFF64B5F6)
val PurpleGradient = Color(0xFFBA68C8)
val LightGray = Color(0xFFF5F5F5)
val DarkGray = Color(0xFF121212)
val InputGray = Color(0xFFE0E0E0)
val DarkInputGray = Color(0xFF2C2C2C)

val Gold = Color(0xFFFFD700)
